// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__2IhM8","paper":"style_paper__9mzDM","content":"style_content__Vosbt","title":"style_title__3BhER","image":"style_image__uDLyn"};